import gql from 'graphql-tag';
import { UserProductDiscountFragment } from '../fragments';

export default gql`
mutation updateUserProductDiscount (
    $id: ID!
    $is_active: Boolean!
    $discount: Float!
    $active_from: String!
    $active_to: String!
) {
    updateUserProductDiscount (input: {
        id: $id,
        is_active: $is_active,
        discount: $discount,
        active_from: $active_from,
        active_to: $active_to,
    }) {
        ...UserProductDiscountFragment
    }
}
${UserProductDiscountFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/updateUserProductDiscount.ts